<template>
	<div>
		<div class="dashboard-flight-deck">
			<div>
				<div class="three-columns">
					<div class="dashboard-tile promotion">
						<div class="title">Open Tickets</div>
						<div class="statistic">
							<div class="stat">{{ openSupportTickets }}</div>
							<div class="caption">Current</div>
						</div>
						<router-link to="/help-center/support-tickets" class="dashboard-link">Manage Support Tickets</router-link>
					</div>
					<div class="dashboard-tile customers">
						<div class="title">Clients</div>
						<div class="statistic">
							<div class="stat">{{ totalClients }}</div>
							<div class="caption">CDS + FFL Office</div>
						</div>
						<router-link to="/admin/clients" class="dashboard-link">Manage Clients</router-link>
					</div>
					<div class="dashboard-tile inventory">
						<div class="title">Products</div>
						<div class="statistic">
							<div class="stat">{{ totalProducts }}</div>
							<div class="caption">Distributor products</div>
						</div>
						<router-link to="/inventory/manage-products/distributor" class="dashboard-link">Manage products</router-link>
					</div>
					<div class="dashboard-tile orderssales">
						<div class="title">Manager Users</div>
						<div class="statistic">
							<div class="stat">{{ totalManagers }}</div>
							<div class="caption">Store Manager Users</div>
						</div>
						<router-link to="/users/user-type-group/managers" class="dashboard-link">Manage users</router-link>
					</div>
					<div class="dashboard-tile blue">
						<div class="title">Domain Names</div>
						<div class="statistic">
							<div class="stat">{{ totalDomains }}</div>
							<div class="caption">Client domain names</div>
						</div>
						<router-link to="/legacy/domainnamemaintenance.php" class="dashboard-link">Manage domain names</router-link>
					</div>
					<div class="dashboard-tile compliance" style="position: relative;">
						<div class="title">Dealer Map</div>
						<div class="statistic" style ="position: relative;">
							<img src="@/assets/img/map.png" style="position: absolute; max-height: 6em;">
						</div>

						<router-link to="/legacy/dealermapbeta.php" class="dashboard-link">View dealer map</router-link>
					</div>
				</div>
			</div>

			<div v-if="alerts.length > 0" class="alerts">
				<div v-for="(alert, index) in alerts" :key="index" :class="['alert-tile', 'alert-' + alert.type]" @click="manageAlert(alert)">
					<div class="title">{{ alert.title }}</div>
					<div class="alert-content">
						<div v-html="alert.content"></div>
						<img v-if="alert.video_thumbnail" :src="alert.video_thumbnail" @click="playVideo(alert.link.replace('video:',''))" style="cursor: pointer;">
					</div>
					<router-link v-if="alert.link" :to="alert.link">{{ alert.link_label}}...</router-link>
				</div>
			</div>
			<div v-else class="empty-list">You have no<br>new messages</div>

		</div>

	</div>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
	name: 'admin-dashboard',
	data() {
		return {
			loading: [],
			openSupportTickets: 0,
			totalClients: 0,
			totalProducts: 0,
			totalManagers: 0,
			totalDomains: 0,
			alerts: [],
			dashboardMenu: {}
		}
	},
	mounted() {
		this.fetchData()
		this.getAlerts()
	},
	methods: {
		fetchData() {
            this.loading.push('getNavCenterStats')
            this.loading.push('getMenuRecursive')
			this.apiCall({ destination: 'get_admin_dashboard_stats' }).then(obj => {
				this.openSupportTickets = obj.open_support_tickets
				this.totalClients = obj.clients
				this.totalProducts = obj.products
				this.totalManagers = obj.manager_users
				this.totalDomains = obj.domains
                this.loading.splice(this.loading.indexOf('getNavCenterStats'), 1)
			}).catch(err => {
                this.loading.splice(this.loading.indexOf('getNavCenterStats'), 1)
				console.log(err)
			})
		},
		getAlerts() {
			this.apiCall({ destination: 'get_alerts' }).then(obj => {
				this.alerts = obj.alerts
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.three-columns {
	margin: 1em 0;
}
.dashboard-tile {
	height: 100%;
	display: grid;
	grid-template-rows: 1.5em auto 3.5em;
}
</style>
